import styled from 'styled-components';
import { prefix } from '../../tools/settings';
import Collapsible from '../Collapsible';
import Scrollable from '../Scrollable';
import Subheading from '../Subheading';
var Tree = styled.div.withConfig({
  displayName: "Treestyles__Tree",
  componentId: "sc-ixjbkz-0"
})(["height:100%;padding:var(--dentsu-spacing-8) var(--dentsu-spacing-16) var(--dentsu-spacing-12) 0;"]);
var ScrollPane = styled(Scrollable).withConfig({
  displayName: "Treestyles__ScrollPane",
  componentId: "sc-ixjbkz-1"
})(["border:1px solid var(--dentsu-color-n200);position:relative;&:before{content:'';position:absolute;top:0;left:0;right:0;height:30px;z-index:1;background-image:linear-gradient( 0deg,rgba(255,255,255,0) 50%,rgba(0,0,0,0.07) 100% );pointer-events:none;}&:after{content:'';position:absolute;bottom:0;left:0;right:0;height:30px;z-index:1;background-image:linear-gradient( 180deg,rgba(255,255,255,0) 50%,rgba(0,0,0,0.07) 100% );pointer-events:none;}.os-scrollbar-corner.os-scrollbar-corner-resize{z-index:2;width:16px;height:16px;background:none;&:before{content:'';position:absolute;top:3px;left:1px;width:13px;height:1px;background:var(--dentsu-color-n550);transform:rotate(-45deg);transform-origin:100% 100%;border-radius:2px;}&:after{content:'';position:absolute;top:8px;left:8px;width:6px;height:1px;background:var(--dentsu-color-n550);transform:rotate(-45deg);transform-origin:100% 100%;border-radius:2px;}}"]);
var TreeLeaf = styled.div.withConfig({
  displayName: "Treestyles__TreeLeaf",
  componentId: "sc-ixjbkz-2"
})([""]);
var Node = styled.div.withConfig({
  displayName: "Treestyles__Node",
  componentId: "sc-ixjbkz-3"
})(["display:flex;align-items:flex-start;padding:10px 0 10px 24px;position:relative;&:before{position:absolute;content:'';left:24px;bottom:0;right:0;height:1px;background:var(--dentsu-color-n300);}&.", "-tree__node--isParent{padding-left:0;&.", "-tree__node--isRootNode{padding-left:var(--dentsu-spacing-24);}}.", "-checkbox{line-height:var(--dentsu-leading-none);.bp3-control-indicator{margin:1px 0;}label span{padding-top:0;}}"], prefix, prefix, prefix);
var NodeChildren = styled(Collapsible).withConfig({
  displayName: "Treestyles__NodeChildren",
  componentId: "sc-ixjbkz-4"
})([""]);
var ExpandToggle = styled.button.withConfig({
  displayName: "Treestyles__ExpandToggle",
  componentId: "sc-ixjbkz-5"
})(["display:flex;align-items:center;justify-content:center;color:var(--dentsu-color-n600);background:none;border:none;margin:0 var(--dentsu-spacing-4) 0 0;padding:0;line-height:0;width:20px;height:20px;outline:none;&:hover{cursor:pointer;}.", "-tree__node--isDisabled &{color:var(--dentsu-color-n500);}.", "-tree__node--isExpanded &{color:var(--dentsu-color-blue);}"], prefix, prefix);
var Label = styled.div.withConfig({
  displayName: "Treestyles__Label",
  componentId: "sc-ixjbkz-6"
})(["font-size:var(--dentsu-font-size-14);line-height:1.45;"]);
var Metadata = styled.div.withConfig({
  displayName: "Treestyles__Metadata",
  componentId: "sc-ixjbkz-7"
})(["color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-12);line-height:var(--dentsu-leading-tight);padding-top:var(--dentsu-spacing-2);text-align:right;margin-left:auto;.", "-tree__node--isDisabled &{color:var(--dentsu-color-n500);}"], prefix);
var EmptyState = styled.div.withConfig({
  displayName: "Treestyles__EmptyState",
  componentId: "sc-ixjbkz-8"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;height:100%;padding:var(--dentsu-spacing-16);text-align:center;"]);
var EmptyStateTitle = styled(Subheading).withConfig({
  displayName: "Treestyles__EmptyStateTitle",
  componentId: "sc-ixjbkz-9"
})(["max-width:350px;margin-bottom:var(--dentsu-spacing-8);font-weight:var(--dentsu-font-weight-semibold);font-size:var(--dentsu-font-size-16);line-height:var(--dentsu-leading-normal);"]);
var EmptyStateDescription = styled.p.withConfig({
  displayName: "Treestyles__EmptyStateDescription",
  componentId: "sc-ixjbkz-10"
})(["max-width:350px;color:var(--dentsu-color-n700);font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-14);line-height:var(--dentsu-leading-normal);"]);
export var Styled = {
  EmptyState: EmptyState,
  EmptyStateTitle: EmptyStateTitle,
  EmptyStateDescription: EmptyStateDescription,
  Tree: Tree,
  TreeLeaf: TreeLeaf,
  ExpandToggle: ExpandToggle,
  Label: Label,
  Metadata: Metadata,
  Node: Node,
  NodeChildren: NodeChildren,
  ScrollPane: ScrollPane
};